// extracted by mini-css-extract-plugin
export default {"container":"TermsOfServicesPage_container__EQtl3","highlightedText":"TermsOfServicesPage_highlightedText__oC9G-"};